<template>
  <div class="news">
    <!-- banner -->
    <banner content="向阳而生 光而不耀 心有神火 语重心长" title="瑞阳心语" type='2'/>
    <!-- 导航栏 -->
    <div v-if="width >= 1200" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="公司简介" name="1"></el-tab-pane>
        <el-tab-pane label="公司荣誉" name="2"></el-tab-pane>
        <el-tab-pane label="科研成果" name="3"></el-tab-pane>
        <el-tab-pane label="合作院校" name="4"></el-tab-pane>
        <el-tab-pane label="联系我们" name="5"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="width <= 768" class="nav">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="公司简介" name="1"></el-tab-pane>
        <el-tab-pane label="公司荣誉" name="2"></el-tab-pane>
        <el-tab-pane label="科研成果" name="3"></el-tab-pane>
        <el-tab-pane label="合作院校" name="4"></el-tab-pane>
        <el-tab-pane label="联系我们" name="5"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 公司简介 -->
    <div v-if="width >= 1200" class="profile" style="width: 1440px;margin: 0 auto;text-indent:2em;">
      <div style="z-index:-1">
        <el-carousel height="709px" indicator-position="outside" style="width:950px">
          <el-carousel-item v-for="(list, index) in profile.picture" :key="index" class="el-car-item">
            <img :src="imgserver + list" alt="" style="border-radius: 10px">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="right" style="z-index:888">
        <div class="profileTitle">瑞阳心语</div>
        <div class="titleEnglish"><span class="row"></span>RUI YANG XIN YU</div>
        <p class="ql-editor ql-container ql-snow" v-html="profile.title.replace(/\n/gm, '<br>')"></p>
      </div>
    </div>
    <div v-if="width <= 768" class="profiles">
      <div class="etitle">瑞阳心语</div>
      <!-- <img style="border-radius: 10px" :src="imgserver + profile.picture" alt=""> -->
      <div style="z-index:-1">
        <el-carousel height="210px" indicator-position="outside" style="width:100%">
          <el-carousel-item v-for="(list, index) in profile.picture" :key="index" class="el-car-item">
            <img :src="imgserver + list" alt="" style="border-radius: 10px">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="rightbox" style="z-index:888">
<!--        <div class="right">-->
<!--          -->
<!--        </div>-->
        <ellipsis v-if="!isUnfold" @click-btn="handleClickBtn" :content="profile.title.replace(/<.*?>/ig,'')" :rows="6" style="font-size: 14px"/>
        <div v-else class="ql-container ql-snow">
          <p  v-html="profile.title"></p>
          <p style="margin-top: 10px;cursor: pointer;color: #4791ff;" @click="isUnfold = false">全部收起</p>
        </div>
      </div>
    </div>
    <div v-if="width >= 1200" class="body">
      <!-- 公司荣誉 -->
      <div id="honors" class="honors">
        <div class="honorsTitle">公司荣誉</div>
        <div class="honerImg">
          <!-- <div class="imgBox" v-for="(item,index) in honorList" :key="index">
              <img :src="imgserver + item.picture" alt="">
          </div> -->
          <el-carousel height="300px" indicator-position="outside" style="width:1440px">
            <el-carousel-item v-for="(list, index) in honorList" :key="index" class="el-car-item">
              <div class="bottomImgs">
                <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList.picture" class="imgBox"
                     style="border-radius: 10px"/>
              </div>
            </el-carousel-item>
          </el-carousel>

        </div>
      </div>
    </div>
    <!-- 公司荣誉 -->
    <div v-if="width < 768" id="honors" class="honors">
      <div class="etitle">公司荣誉</div>
      <div class="honerImg">
        <el-carousel height="100px" indicator-position="outside" style="width:1440px">
          <el-carousel-item v-for="(list, index) in honorList" :key="index" class="el-car-item">
            <div class="bottomImgs">
              <img v-for="(imgList,index2) in list" :key="index2" :src="imgserver + imgList.picture" class="imgBox"
                   style="border-radius: 10px"/>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>
    <!-- 科研成果 -->
    <div v-if="width >= 1200" id="research" class="research">
      <div class="honorsTitle">科研成果</div>
      <div class="honerImg">
        <!-- <div class="imgBox" v-for="(item,index) in researchList" :key="index">
            <img :src="imgserver + item.picture" alt="">
            <p>{{ item.title }}</p>
        </div> -->
        <el-carousel height="560px" indicator-position="outside" style="width:1440px">
          <el-carousel-item v-for="(list, index) in researchList" :key="index" class="el-car-item">
            <div class="bottomImgs">
              <template v-for="(imgList,index2) in list">
                <div style="display:block;text-align:center">
                  <img :key="index2" :src="imgserver + imgList.picture" class="imgBox" style="border-radius: 10px"/>
                  <!-- <div style="text-align:center"> -->
                  <p style="width:80%;height: 52px;line-height:52px;border-radius: 148px;border: 1px solid #34A59A;margin:0 10%;margin-top:30px;">
                    {{ imgList.title }}</p>
                  <!-- </div> -->
                </div>

              </template>
            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 科研成果 -->
    <div v-if="width < 768" id="research" class="research">
      <div class="etitle">科研成果</div>
      <div class="honerImg">
        <div v-for="(item,index) in researchList2" :key="index" class="imgBox">
          <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
          <p style="font-size: 10px;font-weight:600;width:140px;height: 26px;line-height:26px;border-radius: 131px;border: 1px solid #34A59A;padding:5px 10px;margin-bottom: 10px;">
            {{ item.title }}</p>
        </div>
      </div>
    </div>
    <div v-if="width >= 1200" class="body">
      <!-- 合作院校 -->
      <div id="partners" class="partners">
        <div class="honorsTitle">合作院校</div>
        <div class="honerImg">
          <div v-for="(item,index) in partnersList" :key="index" class="imgBox">
            <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div style="text-align:center;margin-top:50px">
          <el-pagination
              :current-page="query.pageNum"
              :page-size="query.pageSize"
              :total="total"
              background
              layout="total, prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
      <!-- 联系我们 -->
<!--      <div id="contact" class="contact">-->
<!--        <div class="honorsTitle">联系我们</div>-->
<!--        <div class="honerImg">-->
<!--          <div v-for="(item,index) in contactList" :key="index" class="imgBox">-->
<!--            <img :src="item.url" alt="" style="border-radius: 10px">-->
<!--            <p>{{ item.title }}</p>-->
<!--            <div style="color: #666666;font-size:14px">{{ item.content }}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        -->
<!--      </div>-->

    </div>
    <!-- 合作院校 -->
    <div v-if="width < 768" id="partners" class="partners">
      <div class="etitle">合作院校</div>
      <div class="honerImg">
        <div v-for="(item,index) in partnersList" :key="index" class="imgBox">
          <img :src="imgserver + item.picture" alt="" style="border-radius: 10px">
          <p style="font-weight: 600;font-size: 10px;color: #3D3D3D;">{{ item.title }}</p>
        </div>
      </div>
      <div style="text-align:center;margin-top:10px">
        <el-pagination
            :current-page="query.pageNum"
            :page-size="query.pageSize"
            :total="total"
            background
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

    <Contact v-if="width >= 1200"></Contact>
    <Contact v-if="width < 768"></Contact>
    <!-- 联系我们 -->
<!--    <div  id="contact" class="contact">-->
<!--      <div class="etitle">联系我们</div>-->
<!--      <div class="honerImg">-->
<!--        <div v-for="(item,index) in contactList" :key="index" class="imgBox">-->
<!--          <img :src="item.url" alt="" style="border-radius: 10px">-->
<!--          <p style="font-weight:600">{{ item.title }}</p>-->
<!--          <div style="color: #666666;font-size:10px">{{ item.content }}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      -->
<!--    </div>-->
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {getwalkIn, getwalkInList, getSite} from '../api/api'
import ellipsis from "vue-overflow-ellipsis"
import Contact from "../components/contact.vue"
import "vue-overflow-ellipsis/dist/index.css"

export default {
  name: "news",
  components: {
    Banner,
    ellipsis,
    Contact
  },
  data() {
    return {
      activeName: "1",
      hide: false,
      button: true,
      levelList: [
        {
          code: '',
          codeValue: '政府合作'
        },
        {
          code: '',
          codeValue: '学术合作'
        },
        {
          code: '',
          codeValue: '培植孵化'
        },
      ],
      // 等级筛选数据
      itemType: 0, // 等级筛选选中的标识
      materialCode: '', // 分类的code值
      honorList: [],
      researchList: [],
      researchList2: [],
      partnersList: [],
      contactList: [
        {
          url: require("../assets/img/contacttwo (3).png"),
          title: "公司地址",
          content: "山东省青岛市"
        },
        {
          url: require("../assets/img/contacttwo (1).png"),
          title: "联系电话",
          content: "13041490009"
        },
        {
          url: require("../assets/img/contacttwo (2).png"),
          title: "市场直通热线",
          content: "jki8yo2wsg9@163.com"
        }
      ],
      profile: {},
      query: {
        pageNum: 1,
        pageSize: 8
      },
      total: 0,
      isUnfold:false,
      list: {},
      width: document.body.clientWidth,
    };
  },
  mounted() {
    if(this.$route.query.activeName){
      this.activeName = this.$route.query.activeName
      if(this.$route.query.activeName == 1){

        this.$nextTick(() => {
          setTimeout(() => {
            document.getElementById("profile").scrollIntoView({behavior: 'smooth'})
          })
        })

      } else if(this.$route.query.activeName == 2){
        setTimeout(() => {
          document.getElementById("honors").scrollIntoView({behavior: 'smooth'})
        },200)
      } else if(this.$route.query.activeName == 3){
        setTimeout(() => {
          document.getElementById("research").scrollIntoView({behavior: 'smooth'})
        },200)
      } else if (this.$route.query.activeName == 4){
        setTimeout(() => {
          document.getElementById("partners").scrollIntoView({behavior: 'smooth'})
        },200)
      }
    }

    window.onresize = () => {
      return (() => {
        this.width = document.documentElement.clientWidth // 宽
      })()
    }
    // this.width = window.screen.width
    this.onload()
    getSite().then(res => {
      // console.log(res,'rrrrr');
      this.list = res.data.data
      this.contactList[0].content = this.list.address.substr(3)
      this.contactList[1].content = this.list.phone.substr(5)
      this.contactList[2].content = this.list.marketHotLine.substr(7)

    })
  },
  methods: {
    handleClickBtn(){
     this.isUnfold = true
    },
    // 滑动到指定位置
    handleClick(tab, event) {
      // window.console.log(tab.name);
      if (tab.name == 1) {
        document.getElementById("profile").scrollIntoView({behavior: 'smooth'})
        // window.console.log(scrollTop,'scrollTop');
      } else if (tab.name == 2) {
        document.getElementById("honors").scrollIntoView({behavior: 'smooth'})
      } else if (tab.name == 3) {
        document.getElementById("research").scrollIntoView({behavior: 'smooth'})
      } else if (tab.name == 4) {
        document.getElementById("partners").scrollIntoView({behavior: 'smooth'})
      } else if (tab.name == 5) {
        document.getElementById("contact").scrollIntoView({behavior: 'smooth'})
      }
    },
    onload() {
      getwalkIn().then(res => {
        this.profile = res.data.data.intro
        this.honorList = res.data.data.companyList
        let newDataList = []
        let current = 0
        this.honorList.sort((a, b) => a.orderNum - b.orderNum);

        for (let i = 0; i < this.honorList.length; i += 3) {
          newDataList.push(this.honorList.slice(i, i + 3));
        }



        this.honorList = [...newDataList]
        // console.log(this.honorList, 'honorList')

        this.researchList = res.data.data.researchList
        this.researchList2 = res.data.data.researchList

        this.researchList.sort((a, b) => a.orderNum - b.orderNum);
        let newDataLists = []
        for (let i = 0; i < this.researchList.length; i += 4) {
          newDataLists.push(this.researchList.slice(i, i + 4));
        }
        this.researchList = [...newDataLists]
      })

      getwalkInList(this.query).then(res => {
        this.partnersList = res.data.rows
        this.total = res.data.total
      })
    },
    // 分页
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.onload();
    },
    handleCurrentChange(current) {
      this.query.pageNum = current;
      this.onload();
    },
    // 了解更多
    more() {
      this.hide = true
      this.button = false
    },
    // 等级筛选互斥效果
    materTay(itemType, code) {
      // 等级筛选选中的标识-高亮效果
      this.itemType = itemType
      // 分类的code值
      this.materialCode = code
    }
  },
};
</script>

<style lang="scss" scoped>
@import url('../assets/font/font.css');

* {
  margin: 0;
  padding: 0;
  font-family: Microsoft YaHei;
  font-size: 16px;
}

.body {
  width: 1440px;
  margin: 0 auto;
}

//改tab
.nav {
  width: 100%;
  // padding: 20px 0 0 0;
  height: 50px;
  line-height: 50px;
  box-shadow: 0px 4px 10px 0px #E9F5F9;
  margin-bottom: 20px;
  box-sizing: border-box;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: none !important;
  background-color: #fff !important;
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
}

::v-deep .el-tabs__nav-scroll {
  width: 1440px;
  margin: 0 auto;
}

//结束
::v-deep .el-tabs__item {
  color: #666666 !important;
}

::v-deep .el-tabs--card {
  border: 0 !important;
}

::v-deep .el-tabs__item .is-active {
  color: #34A59A !important;
}

::v-deep .el-tabs__item:hover {
  color: #333333 !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #fff !important;
  color: #34A59A !important;
  border-bottom-color: transparent !important;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

@media (min-width: 1200px) {
  .profile {
    width: 100%;
    box-sizing: border-box;
    padding: 40px 0;
    position: relative;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    img {
      width: 917px;
      height: 709px;
      // height: 80%;
    }

    .right {
      position: absolute;
      left: 38%;
      top: 11%;
      width: 52.5%;
      height: 75%;
      background-color: #fff;
      display: inline-block;
      box-sizing: border-box;
      padding: 30px 30px 30px 50px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .profileTitle {
        font-size: 30px;
        color: #333333;
        font-weight: 700;
      }

      .titleEnglish {
        font-size: 18px;
        line-height: 15px;
        color: #000000;
        margin-top: 10px;
        margin-bottom: 20px;

        .row {
          display: inline-block;
          width: 15px;
          height: 15px;
          border-radius: 50%;
          border: 3px solid #3DCDD0;
          margin-right: 5px;
        }
      }

      p {
        font-size: 14px;
        letter-spacing: 0em;
        color: #3D3D3D;
        margin-top: 20px;
      }

      .el-button.is-round {
        border-color: #3DCDD0;
        color: #3DCDD0;
        margin-top: 50px;
        width: 15%;
      }
    }

  }
  .honors {
    width: 100%;
    padding: 50px 0;
    box-sizing: border-box;
    text-align: center;

    .honorsTitle {
      // font-weight: 300;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      font-size: 30px;
      font-weight: 700;
    }

    .bottomImgs {
      width: 100%;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      // margin-top: 50px;
      img {
        width: 446px;
        height: 266px;
        margin: 30px 0;
      }
    }

    .honerImg {
      width: 1440px;
      // overflow: hidden; 滚动
      // overflow-x: auto;
      // white-space: nowrap;
      display: flex;
      justify-content: space-between;
      // flex: 3;
      .imgBox {
        width: 445px;
        // width: 30%;
        // width: 446px;
        // display: inline-block;
        // margin-right: 50px;
        img {
          width: 445px;
          margin: 30px 0;
        }

        // p{
        //     font-size: 24px;
        //     font-weight: normal;
        //     line-height: normal;
        //     letter-spacing: 0em;
        //     color: #3D3D3D;
        // }
      }
    }

  }
  .research {
    width: 100%;
    // padding: 50px 220px 0 220px;
    box-sizing: border-box;
    // height: 88vh;
    text-align: center;
    background-image: url("../assets/img/image.png");
    background-size: 100% 100%;

    .bottomImgs {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-top: 50px;
      img {
        width: 336px;
        height: 448px;
        // margin: 30px 0;
      }
    }

    .honorsTitle {
      font-weight: 300;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      font-weight: 700;
      font-size: 30px;
      margin-bottom: 30px;
    }

    .honerImg {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .imgBox {
        // // width: 24%;
        // width: 337px;
        img {
          width: 337px;
          height: 448px;
        }

        p {
          font-size: 14px;
          color: #3D3D3D;
          padding: 10px;
          margin: 0 20px;
          border-radius: 148px;
          box-sizing: border-box;
          border: 1px solid #34A59A;
        }
      }
    }

  }
  .partners {
    width: 100%;
    padding: 50px 0;
    box-sizing: border-box;
    // height: 120vh;
    text-align: center;

    .honorsTitle {
      font-weight: 300;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      font-size: 30px;
      margin-bottom: 50px;
      font-weight: 700;
    }

    .level-screening {
      // padding-left: 40px;
      box-sizing: border-box;
      height: 40px;
      text-align: center;
      line-height: 80px;

      .el-button {
        background-color: #fff;
        // color: #34A59A;
        border-radius: 10px;
        color: #666666;
        padding: 10px;
        border-color: #f5f5f5;
        margin-right: 30px;
      }

      .highlight {
        background: #34A59A !important;
        color: #fff;
      }
    }

    .honerImg {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 4;

      .imgBox {
        width: 23%;

        img {
          width: 100%;
          height: 222px;
          margin: 30px 0;
          border-radius: 10px;
        }

        p {
          font-weight: 600;
        }
      }
    }

  }
  .contact {
    width: 850px;
    padding: 40px 0 100px 0;
    box-sizing: border-box;
    margin: 0 auto;
    // height: 50vh;
    text-align: center;

    .honorsTitle {
      font-weight: 300;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      font-size: 30px;
      font-weight: 700;
    }

    .honerImg {
      width: 100%;
      display: flex;
      justify-content: space-around;
      box-sizing: border-box;
      // padding: 0 100px ;
      .imgBox {
        width: 30%;

        img {
          width: 48px;
          height: 48px;
          margin-top: 30px;
        }

        p {
          font-size: 18px;
          color: #3D3D3D;
          padding: 20px;
          // margin: 0 20px;
        }
      }
    }

  }
}

@media (max-width: 1200px) {
  .nav {
    width: 100%;
    // padding: 20px 0 0 0;
    height: 50px;
    line-height: 50px !important;
    box-shadow: 0px 4px 10px 0px #E9F5F9;
    margin-bottom: 20px;
    box-sizing: border-box;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
    border: none !important;
    background-color: #fff !important;
    font-size: 14px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    height: 30px;
  }
  ::v-deep .el-tabs__nav-scroll {
    width: 100%;
    margin: 0 auto;
  }
  .etitle {
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0em;
    color: #333333;
    text-align: center;
    margin-bottom: 20px;
  }
  .profiles {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;

    img {
      width: 100%;
    }

    .rightbox {
      position: relative;
      width: 90%;
      padding: 20px;
      top: -102px;
      box-shadow: 0px 4px 10px 0px #E9F5F9;
      box-sizing: border-box;
      margin: 0 auto;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, #FFFFFF 100%);
      p {
        font-size: 14px;
        letter-spacing: 0em;
        color: #333333;
        // margin-top: 20px;
      }
      //height: 600px;
    }

    .right {
      position: absolute;
      left: 20px;
      top:-82px;
      //bottom: -2%;
      width: 90%;
      //height: 650px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, #FFFFFF 100%);
      box-shadow: 0px 4px 10px 0px #E9F5F9;
      box-sizing: border-box;
      padding: 20px;
      // text-align: center;
      p {
        font-size: 14px;
        letter-spacing: 0em;
        color: #333333;
        // margin-top: 20px;
      }

      .el-button.is-round {
        border-color: #3DCDD0;
        color: #3DCDD0;
        margin-top: 10px;
        width: 20%;
        padding: 5px;
        font-size: 12px;
      }
    }

  }
  .honors {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    text-align: center;

    .honorsTitle {
      letter-spacing: 0px;
      color: #333333;
      font-size: 18px;
      font-weight: 700;
    }

    .bottomImgs {
      width: 100%;
      display: flex;
      justify-content: space-between;

      img {
        width: 110px;
        height: 68px;
        margin: 30px 0;
      }
    }

    .honerImg {
      width: 100%;
      display: flex;
      justify-content: space-around;

      .imgBox {
        width: 110px;

        img {
          width: 110px;
          height: 68px;
        }
      }
    }

  }
  .research {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    padding: 20px;

    .honerImg {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .imgBox {

        img {
          width: 161px;
          height: 219px;
        }
      }
    }

  }
  .partners {
    width: 100%;
    padding: 30px 20px;
    box-sizing: border-box;
    // height: 120vh;
    text-align: center;

    .honorsTitle {
      font-weight: 300;
      line-height: 50px;
      letter-spacing: 0px;
      color: #333333;
      font-size: 30px;
      // margin-bottom: 50px;
      font-weight: 700;
    }

    .level-screening {
      // padding-left: 40px;
      box-sizing: border-box;
      height: 20px;
      text-align: center;
      line-height: 40px;

      .el-button {
        background-color: #fff;
        // color: #34A59A;
        border-radius: 10px;
        color: #666666;
        padding: 10px;
        border-color: #f5f5f5;
        margin-right: 30px;
      }

      .highlight {
        background: #34A59A !important;
        color: #fff;
      }
    }

    .honerImg {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex: 4;

      .imgBox {
        width: 23%;

        img {
          width: 90px;
          height: 72px;
          // margin: 30px 0;
          // margin-bottom: 10px;
          border-radius: 10px;
        }

        p {
          font-size: 12px;
          color: #3D3D3D;
          width: 100%;
          margin-bottom: 10px;
          // height: 25px;
          // overflow: hidden;
        }
      }
    }

  }
  .contact {
    width: 100%;
    padding-bottom: 30px;
    box-sizing: border-box;
    margin: 0 auto;
    // height: 50vh;
    text-align: center;

    .honerImg {
      width: 100%;
      display: flex;
      justify-content: space-around;
      box-sizing: border-box;
      // padding: 0 100px ;
      .imgBox {
        width: 30%;

        img {
          width: 48px;
          height: 48px;
          // margin-top: 30px;
        }

        p {
          font-size: 12px;
          color: #3D3D3D;
          padding: 10px;
          // margin: 0 20px;
        }
      }
    }

  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fff !important;
  border: 1px solid #3DCDD0;
  color: #3DCDD0;
  border-radius: 50%;
}

::v-deep .el-pagination.is-background .el-pager li {
  box-shadow: 0px 0px 4px 0px rgba(102, 102, 102, 0.25);
  background-color: #fff !important;
  color: #666666;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  line-height: 50px;
  margin-left: 40px;
}

::v-deep .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center
}

::v-deep .el-pagination.is-background .btn-prev {
  border: 1px solid #909090;
  background-color: #fff !important;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination.is-background .btn-next {
  border: 1px solid #909090;
  background-color: #fff !important;
  border-radius: 50%;
  width: 34px;
  height: 34px;
  line-height: 34px;
  margin-left: 40px;
}

</style>
